"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType"));
const findFilterByKey_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findFilterByKey"));
const queryFieldKeyToDataType_1 = __importDefault(require("@opsbase/lib-data-queryfield/helpers/queryFieldKeyToDataType"));
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey/QueryFieldKey"));
const lib_data_staticfieldoptions_1 = __importDefault(require("@opsbase/lib-data-staticfieldoptions"));
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType/FormQuestionType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const WorkflowCondition_1 = require("@opsbase/lib-workflow/WorkflowCondition");
const OperatorType_1 = __importDefault(require("@opsbase/lib-workflow/WorkflowCondition/OperatorType"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const DataPill_1 = __importDefault(require("@opsbase/web-chips/DataPill/DataPill"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const PickBoolean_1 = __importDefault(require("@opsbase/web-dvl-toolbar/pickers/PickBoolean"));
const PickEntity_1 = __importDefault(require("@opsbase/web-dvl-toolbar/pickers/PickEntity"));
const PickSPT_1 = __importDefault(require("@opsbase/web-dvl-toolbar/pickers/PickSPT"));
const PickStatic_1 = __importDefault(require("@opsbase/web-dvl-toolbar/pickers/PickStatic"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal/Horizontal"));
const QuestionTypeIcon_1 = __importDefault(require("@opsbase/web-opform-editor/QuestionTypeIcon/QuestionTypeIcon"));
const DatePicker_1 = __importDefault(require("@opsbase/web-pickers/DatePicker/DatePicker"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur/TextFieldWithStateAndBlur"));
const PlaceTreeView_1 = __importDefault(require("@opsbase/web-treeview/PlaceTreeView/PlaceTreeView"));
const IconMenu_1 = __importDefault(require("@opsbase/web-ui/IconMenu"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const AnswerOptionsPicker_1 = __importDefault(require("./AnswerOptionsPicker"));
const WorkflowConditionPicker_1 = require("./WorkflowConditionPicker");
// eslint-disable-next-line no-shadow
var MenuType;
(function (MenuType) {
    MenuType[MenuType["SEARCH"] = 0] = "SEARCH";
    MenuType[MenuType["DATE"] = 1] = "DATE";
    MenuType[MenuType["STATIC"] = 2] = "STATIC";
    MenuType[MenuType["SPT"] = 3] = "SPT";
    MenuType[MenuType["BOOLEAN"] = 4] = "BOOLEAN";
    MenuType[MenuType["SCORE"] = 5] = "SCORE";
    MenuType[MenuType["NUMBER"] = 6] = "NUMBER";
    MenuType[MenuType["QUESTION"] = 7] = "QUESTION";
    MenuType[MenuType["RELATIVE_DATE"] = 8] = "RELATIVE_DATE";
})(MenuType || (MenuType = {}));
const makeMyClasses = () => ({
    root: {
        borderLeft: '5px solid white',
        '&:hover': {
            borderColor: lib_palette_1.default.secondary.main,
        },
    },
});
function ConditionPicker(props) {
    const { queryField, value, operator, onChangeValue, options, type, rule } = props;
    const self = (0, useSelf_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const basicInputProps = (0, react_1.useMemo)(() => ({
        style: {
            width: 80,
        },
    }), []);
    const textInputProps = (0, react_1.useMemo)(() => ({
        style: {
            width: 90,
            padding: '4px !important',
        },
    }), []);
    const percentInputProps = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, textInputProps), { endAdornment: (react_1.default.createElement(Text_1.default, { variant: "small", color: "lightgrey" }, "%")) })), [textInputProps]);
    const { additionalInputProps, menuType, isIconMenu, displayUnit, fieldOptions } = (0, react_1.useMemo)(() => {
        let aip = textInputProps;
        let mType = MenuType.SEARCH;
        let isIcMenu = true;
        let du = '';
        let fOptions = [];
        if (queryField) {
            const fieldType = queryField.fieldType;
            if (queryField.key === QueryFieldKey_1.default.OP_QUESTION ||
                queryField.key === QueryFieldKey_1.default.OP_ANSWER) {
                mType = MenuType.QUESTION;
                if ([FormQuestionType_1.default.DATETIME, FormQuestionType_1.default.NUMBER].includes(type)) {
                    isIcMenu = false;
                }
            }
            switch (fieldType) {
                case BasicFieldType_1.default.BOOLEAN:
                    mType = MenuType.BOOLEAN;
                    break;
                case BasicFieldType_1.default.RELATED_SPT:
                    mType = MenuType.SPT;
                    break;
                case BasicFieldType_1.default.DATE:
                    mType = MenuType.DATE;
                    isIcMenu = false;
                    break;
                case BasicFieldType_1.default.OP_SCORE:
                    mType = MenuType.SCORE;
                    isIcMenu = false;
                    aip = percentInputProps;
                    break;
                case BasicFieldType_1.default.NUMBER:
                    mType = MenuType.NUMBER;
                    isIcMenu = false;
                    break;
                case BasicFieldType_1.default.TEMPERATURE:
                    mType = MenuType.NUMBER;
                    du = '\xB0C';
                    isIcMenu = false;
                    break;
                case StaticFieldType_1.default.OP_GRADE:
                case StaticFieldType_1.default.ISSUE_TYPE:
                case StaticFieldType_1.default.OP_TYPE:
                case StaticFieldType_1.default.ISSUE_FLAG:
                case StaticFieldType_1.default.OP_STATUS:
                case StaticFieldType_1.default.ORG_STATUS:
                case StaticFieldType_1.default.TASK_TYPE:
                case StaticFieldType_1.default.TASK_STATUS:
                case StaticFieldType_1.default.USER_TYPE:
                case StaticFieldType_1.default.ISSUE_STATUS:
                case StaticFieldType_1.default.ISSUE_DUESTATUS:
                case StaticFieldType_1.default.ISSUE_RESTIME:
                case StaticFieldType_1.default.STAFF_APPSTATUS:
                case StaticFieldType_1.default.OP_PASSSTATUS:
                    fOptions = lib_data_staticfieldoptions_1.default[fieldType](self);
                    mType = MenuType.STATIC;
                    break;
            }
            if (queryField.key === QueryFieldKey_1.default.ASSET_LASTSERVICEDATE) {
                mType = MenuType.RELATIVE_DATE;
            }
        }
        return {
            additionalInputProps: aip,
            fieldOptions: fOptions,
            menuType: mType,
            displayUnit: du,
            isIconMenu: isIcMenu,
        };
    }, [percentInputProps, queryField, self, textInputProps, type]);
    const handleToggleQueryFilter = (0, react_1.useCallback)(e => {
        const valueIndex = value.id.findIndex(v => (queryField === null || queryField === void 0 ? void 0 : queryField.key) === e.queryFieldKey && e.id === v);
        if (valueIndex > -1) {
            value.id.splice(valueIndex, 1);
            value.title.splice(valueIndex, 1);
            value.color.splice(valueIndex, 1);
        }
        else {
            value.id.push(e.id);
            value.title.push(e.title);
            value.color.push(e.color);
        }
        onChangeValue(new WorkflowCondition_1.QueryFieldValue(value));
    }, [value, onChangeValue, queryField]);
    const handleChangeCallbacks = (0, react_1.useRef)({});
    const getChangeHandler = (0, react_1.useCallback)(property => {
        const cb = (v) => {
            onChangeValue(new WorkflowCondition_1.QueryFieldValue(Object.assign(Object.assign({}, value), { [property]: v })));
        };
        handleChangeCallbacks.current[property] = cb;
        return cb;
    }, [onChangeValue, value]);
    const handleTogglePickQuestion = (0, react_1.useCallback)(e => {
        const valueIndex = value.id.findIndex(v => e.nodeId === v);
        value.id = [];
        value.title = [];
        value.color = [];
        if (valueIndex <= -1) {
            value.id.push(e.nodeId);
            value.title.push(e.title);
            value.color.push(e.color);
        }
        onChangeValue(new WorkflowCondition_1.QueryFieldValue(value));
    }, [value, onChangeValue]);
    const qfKey = queryField === null || queryField === void 0 ? void 0 : queryField.key;
    const valueId = value === null || value === void 0 ? void 0 : value.id;
    const valueIdLength = valueId === null || valueId === void 0 ? void 0 : valueId.length;
    let filters = (0, react_1.useMemo)(() => {
        const f = [];
        if (valueIdLength > 0) {
            valueId.forEach((v, i) => {
                f.push({
                    id: v,
                    title: value.title[i],
                    queryFieldKey: qfKey,
                });
            });
        }
        return f;
    }, [valueIdLength, valueId, value.title, qfKey]);
    const handleChangePlaces = (0, react_1.useCallback)(places => {
        places.forEach(p => {
            handleToggleQueryFilter({
                queryFieldKey: QueryFieldKey_1.default.PLACE,
                id: p === null || p === void 0 ? void 0 : p.id,
                title: p === null || p === void 0 ? void 0 : p.title,
            });
        });
    }, [handleToggleQueryFilter]);
    const picker = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        if (queryField) {
            switch (menuType) {
                case MenuType.SEARCH:
                    if (queryField.key === QueryFieldKey_1.default.PLACE) {
                        return (react_1.default.createElement(PlaceTreeView_1.default, { selected: filters
                                .filter(f => f.queryFieldKey === QueryFieldKey_1.default.PLACE)
                                .map(f => f.id), onSelect: handleChangePlaces }));
                    }
                    return (react_1.default.createElement(PickEntity_1.default, { queryField: queryField, filters: filters, onSelect: handleToggleQueryFilter }));
                case MenuType.DATE:
                    return (react_1.default.createElement(Horizontal_1.default, { gutter: true, justify: 'flex-start' },
                        react_1.default.createElement(DatePicker_1.default, { noMargin: true, white: true, value: (_a = (0, moment_timezone_1.default)(value === null || value === void 0 ? void 0 : value.from)) === null || _a === void 0 ? void 0 : _a.toDate(), onChange: getChangeHandler('from') }),
                        operator === OperatorType_1.default.BETWEEN ? (react_1.default.createElement(DatePicker_1.default, { noMargin: true, white: true, value: (_b = (0, moment_timezone_1.default)(value === null || value === void 0 ? void 0 : value.to)) === null || _b === void 0 ? void 0 : _b.toDate(), onChange: getChangeHandler('to') })) : ('')));
                case MenuType.RELATIVE_DATE:
                    return (react_1.default.createElement(Horizontal_1.default, { gutter: true, justify: 'flex-start' },
                        react_1.default.createElement(WorkflowConditionPicker_1.TimeBit, { value: parseInt((_c = value === null || value === void 0 ? void 0 : value.from) === null || _c === void 0 ? void 0 : _c.toString()), onChangeValue: getChangeHandler('from'), unit: (value === null || value === void 0 ? void 0 : value.valueUnit) || 'day', onChangeUnit: getChangeHandler('valueUnit'), items: ['day', 'month', 'year'] })));
                case MenuType.STATIC:
                    return (react_1.default.createElement(PickStatic_1.default, { fieldOptions: fieldOptions, filters: filters, onSelect: handleToggleQueryFilter }));
                case MenuType.SPT:
                    return (react_1.default.createElement(PickSPT_1.default, { queryField: queryField, filters: filters, onSelect: handleToggleQueryFilter }));
                case MenuType.BOOLEAN:
                    return (react_1.default.createElement(PickBoolean_1.default, { queryField: queryField, filters: filters, onSelect: handleToggleQueryFilter }));
                case MenuType.NUMBER:
                case MenuType.SCORE:
                    return (react_1.default.createElement(Horizontal_1.default, { gutter: true, justify: 'flex-start' },
                        react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { noMargin: true, value: value === null || value === void 0 ? void 0 : value.from, onBlur: getChangeHandler('from'), type: "number", InputProps: Object.assign(Object.assign({}, additionalInputProps), { endAdornment: (react_1.default.createElement(Text_1.default, { variant: "small", color: "lightgrey" }, displayUnit)) }), inputProps: basicInputProps }),
                        operator === OperatorType_1.default.BETWEEN ? (react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { noMargin: true, value: value === null || value === void 0 ? void 0 : value.to, onBlur: getChangeHandler('to'), type: "number", InputProps: Object.assign(Object.assign({}, additionalInputProps), { endAdornment: (react_1.default.createElement(Text_1.default, { variant: "small", color: "lightgrey" }, displayUnit)) }), inputProps: basicInputProps })) : ('')));
                case MenuType.QUESTION: {
                    if (qfKey === QueryFieldKey_1.default.OP_QUESTION && (options === null || options === void 0 ? void 0 : options.length)) {
                        return (react_1.default.createElement(react_1.default.Fragment, null, options === null || options === void 0 ? void 0 : options.map(fieldOption => {
                            const isSelected = !!(0, findFilterByKey_1.default)(filters, fieldOption.queryFieldKey, fieldOption.id);
                            return (react_1.default.createElement(MenuItem_1.default, { key: fieldOption.id, maxWidth: 240, onClick: () => handleTogglePickQuestion(fieldOption), classes: { root: myCss.root }, showTick: isSelected },
                                react_1.default.createElement(Horizontal_1.default, { gutter: true, centered: true, justify: 'flex-start' },
                                    react_1.default.createElement(QuestionTypeIcon_1.default, { type: fieldOption.type, color: "#222222" }),
                                    react_1.default.createElement(Text_1.default, null, fieldOption.title))));
                        })));
                    }
                    else if (qfKey === QueryFieldKey_1.default.OP_ANSWER) {
                        return (react_1.default.createElement(AnswerOptionsPicker_1.default, { type: type, filters: filters, queryField: queryField, value: value, operator: operator, rule: rule, getChangeHandler: getChangeHandler, handleToggleChangeAnswer: handleToggleQueryFilter }));
                    }
                }
            }
        }
        return null;
    }, [
        additionalInputProps,
        basicInputProps,
        displayUnit,
        fieldOptions,
        filters,
        getChangeHandler,
        handleChangePlaces,
        handleTogglePickQuestion,
        handleToggleQueryFilter,
        menuType,
        myCss.root,
        operator,
        options,
        qfKey,
        queryField,
        rule,
        type,
        value,
    ]);
    const dataType = (0, react_1.useMemo)(() => (0, queryFieldKeyToDataType_1.default)(queryField === null || queryField === void 0 ? void 0 : queryField.key), [queryField]);
    return isIconMenu ? (react_1.default.createElement(IconMenu_1.default, { small: true, color: lib_palette_1.default.White, bordered: true, minWidth: 50, icon: react_1.default.createElement(Horizontal_1.default, { gutter: true }, value.title.map((t, i) => {
            var _a;
            return (react_1.default.createElement(DataPill_1.default, { key: 'pill' + i, value: t, type: dataType, backgroundColor: ((_a = value === null || value === void 0 ? void 0 : value.color) === null || _a === void 0 ? void 0 : _a[i]) || undefined, onDelete: () => {
                    var _a;
                    return handleToggleQueryFilter({
                        id: (_a = value === null || value === void 0 ? void 0 : value.id) === null || _a === void 0 ? void 0 : _a[i],
                        title: t,
                        queryFieldKey: queryField === null || queryField === void 0 ? void 0 : queryField.key,
                    });
                } }));
        })), label: (value === null || value === void 0 ? void 0 : value.title.length) ? '' : lib_i18n_1.default.t('choose-value'), anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        }, doNotCloseOnClick: true }, picker)) : (picker);
}
exports.default = ConditionPicker;
